<script setup>
import { getPagina } from '@/services/api.js'
import Sk from '@/components/usefulness/Sk.vue'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { usePageDataStore } from '@/stores/pageData.js'

const pageData = usePageDataStore()
const route = useRoute()

const id = ref(route.params.id)
const title = ref('')
const text = ref('')
const loading = ref(true)

function applyPage(data) {
  title.value = data.title ?? ''
  text.value = data.text ?? ''
  loading.value = false
}

async function getPag() {
  loading.value = true
  const cached = pageData.page
  if (cached && String(cached.id) === String(id.value)) {
    applyPage(cached)
    return
  }

  const data = await getPagina(id.value)
  if (!data[0]?.error) {
    applyPage(data[0])
  } else {
    loading.value = false
  }
}

if (pageData.page && String(pageData.page.id) === String(id.value)) {
  applyPage(pageData.page)
}

if (loading.value) {
  getPag()
}

watch(() => route.params.id, (newId) => {
  id.value = newId
  getPag()
})
</script>

<template>
  <div class="page">
    <div class="top">
      <div class="icon"></div>
      <div class="title">
        <span v-if="!loading">{{ title }}</span>
        <Sk v-else w="180px" h="16px" extra="my-1" />
      </div>
    </div>
    <template v-if="loading">
      <div class="content flex flex-col gap-3">
        <Sk w="100%" h="14px" />
        <Sk w="92%" h="14px" />
        <Sk w="97%" h="14px" />
        <Sk w="75%" h="14px" />
      </div>
    </template>
    <div v-else class="content not-tailwind" v-html="text"></div>
  </div>
</template>

<style scoped>
.page .top .icon {
  background-color: #21415C;
  background-position: -68px -27px;
}
</style>
